import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";

class Menus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ show: false, effect: "zoomOut" });
  }

  handleShow() {
    this.setState({ show: true, effect: "zoomIn" });
  }

  render() {
    return (
      <>
        <span
          style={{
            cursor: "pointer",
            marginRight: "0.5rem",
            width: "2.75rem",
            height: "2.75rem",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#aeb4ce",
          }}
          onClick={this.handleShow}
          className={"btn "}
        >
          <i
            style={{ height: "20px", width: "20px" }}
            className={"mdi mdi-information mr-1"}
          />
          Help
        </span>

        <Modal
          size="sm"
          scrollable={true}
          centered={true}
          backdrop="static"
          show={this.state.show}
          onHide={this.handleClose}
          aria-labelledby="keno-help-modal"
          className={"animated " + this.state.effect}
          dialogClassName="custom-modal-width"
        >
          <Modal.Header className=" border-0 pb-2 position-relative">
            <div className="w-100 text-center">
              <Modal.Title className="text-white fw-bold mb-0">
                {/* <i className="mdi mdi-help-circle me-2"></i> */}
                Keno Help Guide
              </Modal.Title>
            </div>
            <button
              type="button"
              className="custom-close-btn"
              onClick={this.handleClose}
              aria-label="Close"
            >
              <i className="mdi mdi-close"></i>
            </button>
          </Modal.Header>

          <Modal.Body className="modal-helper p-3">
            <div className="text-center mb-3">
              <img
                className="img-fluid rounded shadow-sm"
                src="/assets/images/covers_new/keno.png"
                alt="Keno Game"
                style={{ maxHeight: "120px", objectFit: "contain" }}
              />
            </div>

            <div className="mb-4">
              <p
                className={"text-white mb-3 lh-base"}
                style={{ fontSize: "14px" }}
              >
                Keno is a gambling game played with cards bearing numbers from{" "}
                <strong>1 to 40</strong>. Choose your numbers, submit your bet,
                and win prizes based on how many of your selected numbers are
                drawn.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="text-warning mb-3 d-flex align-items-center">
                <i className="mdi mdi-lightbulb me-2"></i>
                Game Tips & Tricks
              </h5>
              <div className="bg-dark bg-opacity-50 p-3 rounded">
                <ul
                  className="list-unstyled mb-0 text-white"
                  style={{ fontSize: "13px" }}
                >
                  <li className="mb-2">
                    <i className="mdi mdi-check-circle text-success me-2"></i>
                    More numbers = Higher potential payout
                  </li>
                  <li className="mb-2">
                    <i className="mdi mdi-check-circle text-success me-2"></i>
                    Maximum selection: 10 numbers
                  </li>
                  <li className="mb-0">
                    <i className="mdi mdi-check-circle text-success me-2"></i>
                    Mix even & odd numbers for better chances
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-3">
              <h5 className="text-warning mb-3 d-flex align-items-center">
                <i className="mdi mdi-gamepad-variant me-2"></i>
                How to Play
              </h5>
              <div className="row g-2">
                <div className="col-12">
                  <div className="bg-primary bg-opacity-20 p-2 rounded text-center">
                    <span className="badge bg-primary me-2">1</span>
                    <span className="text-white" style={{ fontSize: "13px" }}>
                      Select up to 10 numbers (1-40)
                    </span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="bg-info bg-opacity-20 p-2 rounded text-center">
                    <span className="badge bg-info me-2">2</span>
                    <span className="text-white" style={{ fontSize: "13px" }}>
                      More matches = Higher multiplier
                    </span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="bg-success bg-opacity-20 p-2 rounded text-center">
                    <span className="badge bg-success me-2">3</span>
                    <span className="text-white" style={{ fontSize: "13px" }}>
                      Place bet and wait for results
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="border-0">
            <button
              type="button"
              className="btn btn-outline-light btn-sm w-100"
              onClick={this.handleClose}
            >
              <i className="mdi mdi-check me-1"></i>
              Got it!
            </button>
          </Modal.Footer>
        </Modal>

        <style jsx>{`
          .custom-modal-width {
            max-width: 450px !important;
            margin: 1.75rem auto;
          }

          .modal-helper {
            background: #1e2121;
            color: white;
          }

          .Header {
            background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .custom-close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            width: 32px;
            height: 32px;
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 6px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 16px;
          }

          .custom-close-btn:hover {
            background: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.3);
            transform: scale(1.05);
          }

          .custom-close-btn:active {
            transform: scale(0.95);
          }

          .modal-content {
            border: none;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
          }

          .animated.zoomIn {
            animation: zoomIn 0.3s ease-out;
          }

          .animated.zoomOut {
            animation: zoomOut 0.3s ease-in;
          }

          @keyframes zoomIn {
            from {
              opacity: 0;
              transform: scale(0.3);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes zoomOut {
            from {
              opacity: 1;
              transform: scale(1);
            }
            to {
              opacity: 0;
              transform: scale(0.3);
            }
          }
        `}</style>
      </>
    );
  }
}

export default Menus;
